const initialState = [];

function reducer(state = initialState, action) {
    if (
        action.type === 'LOGOUT_REQUEST' ||
        action.type === 'AUTHENTICATE_REQUEST' ||
        action.type === 'CLUSTER_MONITORING_SERVICES_FAILURE'
    ) {
        return initialState;
    }

    if (action.type === 'CLUSTER_MONITORING_SERVICES_SUCCESS') {
        return action.payload.apmMonitoringServices;
    }

    return state;
}

export default reducer;
